import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { OverlayTrigger, Popover } from "react-bootstrap";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import { contractTypeMap, hoursTypeMap } from "../../helpers/vacancyHelpers";
import VacancyImage from "./VacancyImage";

const StyledTruncatingWrapper = styled.div`
  min-width: 0;
  color: ${({ theme, textColor }) => textColor || theme.negativeTextColor};
`;

function VacancyBar(props) {
  const { thumbnailUrl, companyName, showCompanyName, textColor } = props;

  const { vacancyStore } = useStores();
  const { selectedVacancy } = vacancyStore;

  const vacancyDetailSegments = [
    showCompanyName && companyName,
    selectedVacancy.location?.city,
    hoursTypeMap[selectedVacancy.hoursType],
    contractTypeMap[selectedVacancy.contractType],
    selectedVacancy.companyName,
  ].filter(Boolean);

  const imageUrl = selectedVacancy?.company?.logoUrlFull || thumbnailUrl;

  return (
    <StyledTruncatingWrapper
      className="d-flex align-items-center"
      textColor={textColor}
    >
      <VacancyImage imageUrl={imageUrl} small />
      <StyledTruncatingWrapper className="me-2" textColor={textColor}>
        <OverlayTrigger
          overlay={
            <Popover id="popover-positioned-bottom">
              <Popover.Body>
                <p className="m-0">
                  Applying for:
                  {selectedVacancy?.title || selectedVacancy?.jobTitle}
                </p>
              </Popover.Body>
            </Popover>
          }
          placement="bottom"
          rootClose
          rootCloseEvent="click"
          trigger="click"
        >
          <p className="mb-0 vacancy-heading text-truncate small">
            {(selectedVacancy?.title?.length < 40 ||
              selectedVacancy?.jobTitle?.length < 40) && (
              <span>Applying for: </span>
            )}
            {selectedVacancy?.title || selectedVacancy?.jobTitle}
          </p>
        </OverlayTrigger>
        <p className="mb-0">{vacancyDetailSegments.join(", ")}</p>
      </StyledTruncatingWrapper>
    </StyledTruncatingWrapper>
  );
}

export default observer(VacancyBar);

VacancyBar.defaultProps = {
  companyName: null,
  showCompanyName: false,
  textColor: null,
};

VacancyBar.propTypes = {
  companyName: PropTypes.string,
  showCompanyName: PropTypes.bool,
  textColor: PropTypes.string,
  thumbnailUrl: PropTypes.string.isRequired,
  vacancy: PropTypes.shape({
    contractType: PropTypes.string,
    hoursType: PropTypes.string,
    location: PropTypes.shape({
      city: PropTypes.string,
    }),
    title: PropTypes.string,
  }).isRequired,
};
